import {
  emitCustomEvent,
  useCustomEventListener,
} from 'infrastructure/hooks/utils';

import type { ModuleType } from 'infrastructure/enums';

// CALL END
interface ICallEndedEventDetails {
  patientGuid: string;
  callDuration: number;
  module: ModuleType;
  callId: string;
}

const CALL_ENDED_EVENT_NAME = 'callEnded';

export const emitCallEndedEvent = ({
  callDuration,
  patientGuid,
  module,
  callId,
}: ICallEndedEventDetails) => {
  emitCustomEvent<ICallEndedEventDetails>(CALL_ENDED_EVENT_NAME, {
    callDuration,
    patientGuid,
    module,
    callId,
  });
};

export const useCallEndedEventListener = (
  callback: (event: CustomEvent<ICallEndedEventDetails>) => void,
) => {
  useCustomEventListener<ICallEndedEventDetails>(
    CALL_ENDED_EVENT_NAME,
    callback,
  );
};

// CALL END
interface ICallStartedEventDetails {}

const CALL_STARTED_EVENT_NAME = 'callStarted';

export const emitCallStartedEvent = () => {
  emitCustomEvent<ICallStartedEventDetails>(CALL_STARTED_EVENT_NAME, {});
};

export const useCallStartedEventListener = (
  callback: (event: CustomEvent<ICallStartedEventDetails>) => void,
) => {
  useCustomEventListener<ICallStartedEventDetails>(
    CALL_STARTED_EVENT_NAME,
    callback,
  );
};

// CALL DASHBOARD CALL STARTED
interface ICallDashboardCallStartedEventDetails {}

const CALL_DASHBOARD_CALL_STARTED_EVENT_NAME = 'callDashboardCallStarted';

export const emitCallDashboardCallStartedEvent = () => {
  emitCustomEvent<ICallDashboardCallStartedEventDetails>(
    CALL_DASHBOARD_CALL_STARTED_EVENT_NAME,
    {},
  );
};

export const useCallDashboardCallStartedEventListener = (
  callback: (event: CustomEvent<ICallDashboardCallStartedEventDetails>) => void,
) => {
  useCustomEventListener<ICallDashboardCallStartedEventDetails>(
    CALL_DASHBOARD_CALL_STARTED_EVENT_NAME,
    callback,
  );
};

// CALL DASHBOARD CALL END
interface ICallDashboardCallEndedEventDetails {}

const CALL_DASHBOARD_CALL_ENDED_EVENT_NAME = 'callDashboardCallEnded';

export const emitCallDashboardCallEndedEvent = () => {
  emitCustomEvent<ICallDashboardCallEndedEventDetails>(
    CALL_DASHBOARD_CALL_ENDED_EVENT_NAME,
    {},
  );
};

export const useCallDashboardCallEndedEventListener = (
  callback: (event: CustomEvent<ICallDashboardCallEndedEventDetails>) => void,
) => {
  useCustomEventListener<ICallDashboardCallEndedEventDetails>(
    CALL_DASHBOARD_CALL_ENDED_EVENT_NAME,
    callback,
  );
};
